import { PropsWithChildren, ReactNode } from 'react';
import {
  ChakraHStack,
  ChakraVStack,
  FAIconName,
  FireflyButton,
} from '@equip.health/ui';

type FooterCta = {
  isDisabled?: boolean;
  label: string;
  leftIcon?: FAIconName;
  onClick: () => void;
};

interface FooterProps extends PropsWithChildren {
  id: string;
  primaryCta: FooterCta;
  primaryCtaAddon?: ReactNode;
  secondaryCta: FooterCta;
  tertiaryCta?: FooterCta;
}

const Footer = ({
  children, // render an action bar if needed
  id,
  primaryCta,
  primaryCtaAddon,
  secondaryCta,
  tertiaryCta,
}: FooterProps) => {
  return (
    <ChakraVStack spacing="24px" width="100%">
      {children}
      <ChakraHStack justifyContent="space-between" width="100%">
        <ChakraHStack spacing="24px">
          <FireflyButton
            id={`${id}__secondary-cta`}
            isDisabled={secondaryCta.isDisabled}
            leftIcon={secondaryCta.leftIcon}
            onClick={secondaryCta.onClick}
            variant="secondary"
          >
            {secondaryCta.label}
          </FireflyButton>
          {tertiaryCta && (
            <FireflyButton
              id={`${id}__tertiary-cta`}
              isDisabled={tertiaryCta.isDisabled}
              onClick={tertiaryCta.onClick}
              rightIcon={FAIconName.arrowRightToLineRegular}
              variant="tertiary"
            >
              {tertiaryCta.label}
            </FireflyButton>
          )}
        </ChakraHStack>
        <ChakraHStack spacing="16px">
          {primaryCtaAddon}
          <FireflyButton
            id={`${id}__primary-cta`}
            isDisabled={primaryCta.isDisabled}
            onClick={primaryCta.onClick}
            leftIcon={primaryCta.leftIcon}
            rightIcon={
              primaryCta.leftIcon ? undefined : FAIconName.chevronRightRegular
            }
          >
            {primaryCta.label}
          </FireflyButton>
        </ChakraHStack>
      </ChakraHStack>
    </ChakraVStack>
  );
};

export default Footer;
